import { render, staticRenderFns } from "./FormNewService.vue?vue&type=template&id=278e1216"
import script from "./FormNewService.vue?vue&type=script&lang=js"
export * from "./FormNewService.vue?vue&type=script&lang=js"
import style0 from "./FormNewService.vue?vue&type=style&index=0&id=278e1216&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278e1216')) {
      api.createRecord('278e1216', component.options)
    } else {
      api.reload('278e1216', component.options)
    }
    module.hot.accept("./FormNewService.vue?vue&type=template&id=278e1216", function () {
      api.rerender('278e1216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NewServiceForm/components/FormNewService.vue"
export default component.exports